import React from "react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { breadcrumbLd } from "@/lib/siteContent";
import { ClipboardCheck, MessageSquare, Handshake, ShieldCheck, Scale, FileCheck } from "lucide-react";

const PHASES = [
  { icon: ClipboardCheck, title: "1. Complaint filed", desc: "The complainant documents facts, amounts, and evidence. A unique complaint ID is generated." },
  { icon: MessageSquare, title: "2. Notice & response", desc: "The other party is notified and gets a configurable response period (default 7 days, with clear deadline)." },
  { icon: Scale, title: "3. Under discussion", desc: "Both parties exchange messages and evidence in a private negotiation room. Numbers stay masked." },
  { icon: Handshake, title: "4. Resolution proposed", desc: "Either party proposes a settlement; the other can agree, counter, or request clarification." },
  { icon: FileCheck, title: "5. Resolved by agreement", desc: "On mutual agreement, a neutral settlement record is created and both parties are acknowledged." },
  { icon: ShieldCheck, title: "6. Moderation & appeals", desc: "Disputes can be challenged, moderated, appealed, corrected, or withdrawn under policy." },
];

export default function ResolutionCentre() {
  const crumbs = [{ label: "Home", to: "/" }, { label: "Resolve a Dispute", to: "/resolve-a-dispute" }];
  return (
    <div className="ca-container py-12">
      <Seo title="Resolve Customer and Vendor Disputes | ComplaintAdvisor"
        description="Explore structured communication, evidence sharing, settlement proposals, and dispute-status tracking through ComplaintAdvisor's Resolution Centre."
        path="/resolve-a-dispute" jsonld={breadcrumbLd(crumbs)} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3">Resolve a Dispute</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">How ComplaintAdvisor works: a structured, neutral escalation path that gives both parties a fair opportunity before matters become expensive disputes.</p>
      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {PHASES.map((p, i) => (
          <div key={i} className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="h-11 w-11 rounded-xl bg-teal-brand/10 flex items-center justify-center mb-3">
              <p.icon className="h-6 w-6 text-teal" />
            </div>
            <h4 className="font-semibold text-slate-900">{p.title}</h4>
            <p className="text-sm text-slate-600 mt-1">{p.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 rounded-2xl bg-slate-50 border border-slate-200 p-5 text-sm text-slate-500">
        Note: The platform does not automatically declare an allegation true if the other party does not respond.
        A "No response received" status is recorded, public visibility is restricted, and moderation review is available.
      </div>
    </div>
  );
}
